import styled from 'styled-components';

export default styled.div`
	.msg-list {
		margin-bottom: 12px;
		.mst-list-btn {
			text-align: center;
		}
	}
	.msg-alert {
		padding: 16px 0;
		text-align: center;
		background-color: #fff;
		margin-bottom: 16px;
		font-size: 16px;
		p {
			margin: 0;
		}
	}
	.msg-form {
		position: relative;
		.ant-input {
			border-radius: 0;
			padding-bottom: 44px;
		}
		.msg-length {
			position: absolute;
			right: 8px;
			bottom: 8px;
		}
	}
	.msg-list {
		min-height: 300px;
	}
	.msg-btn {
		margin-bottom: 24px;
		text-align: right;
		.ant-btn {
			width: 90px;
		}
	}
	.msg-row {
		background: #29292C;
	}
`;

export const CommentBox = styled.div`
	padding: 12px 0;
	border: 1px solid #d9d9d9;
	margin-bottom: 8px;
	background-color: #fff;
	position: relative;
	.anticon {
		position: absolute;
		right: 12px;
		top: 12px;
		cursor: pointer;
		color: #f00;
	}
	.msg-row-info {
		padding-left: 50px;
		position: relative;
		.ant-avatar {
			position: absolute;
			left: 9px;
			top: 2px;
		}
		.msg-row-info-name {
			font-weight: bold;
		}
		.msg-row-info-date {
			font-size: 12px;
			color: #d9d9d9;
		}
	}
	.msg-row-content {
		padding: 12px;
		padding-left: 50px;
		word-break: break-word;
	}
	&.creator {
	}
`;
